module.exports = __webpack_public_path__ + "img/poor.2f80f3f7.png";